import type { ComponentPropsWithoutRef, ReactNode } from 'react'

import './style.scss'
import clsx from 'clsx'

export const FormField = ({
	beforeLabel = '',
	children,
	className,
	label,
	required = false
}: ComponentPropsWithoutRef<'div'> & {
	beforeLabel?: ReactNode[] | string
	label?: string
	required?: boolean
}) => (
	<div className={clsx(className, 'field')}>
		<div className='field-body'>
			<div className={clsx('field-label', beforeLabel && 'large-label')}>
				<span className='text-field-label bold'>
					{label} {required && <span className='required'>*</span>}
				</span>
				<span className='text-small-field-label'>
					{Array.isArray(beforeLabel)
						? beforeLabel.map((item, index) => <span key={index}>{item}</span>)
						: beforeLabel}
				</span>
			</div>
			<div className='field-content'>{children}</div>
		</div>
	</div>
)
